<template>
    <Teleport to="body">
        <Transition>
            <div
                v-if="visible"
                class="fixed inset-0 z-1000 main-popup"
                :class="[
                    overlay ? 'bg-black/50' : '',
                    'main-popup-' + keyPopup,
                ]"
                @click.self="
                    closeOverlay ? $emit('update:visible', false) : false
                "
            >
                <div
                    class="absolute transfrom container w-auto flex box-popup"
                    :class="[usePosition(position), 'box-popup-' + keyPopup]"
                >
                    <!-- Default -->
                    <div
                        class="relative pointer-events-auto bg-white rounded-lg p-5 max-w-3xl box-content-popup"
                        :class="['box-content-popup-' + keyPopup]"
                    >
                        <span
                            v-if="closeable"
                            class="i-ic:sharp-close cursor-pointer absolute -top-7 z-10 w-4 h-4 text-white icon-close"
                            :class="[
                                position && position.includes('right')
                                    ? 'left-0'
                                    : 'right-0',
                            ]"
                            @click="closePopup"
                        />
                        <div class="header-popup">
                            <slot v-if="slots['header']" name="header" />
                        </div>

                        <div class="overflow-auto content-popup">
                            <slot />
                        </div>
                        <div class="footer-popup">
                            <slot v-if="slots['footer']" name="footer" />
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>
<script setup lang="ts">
import { onMounted, useSlots } from "vue";
import { useWindowScroll } from "@vueuse/core";

const slots = useSlots();
const props = defineProps({
    keyPopup: {
        type: String,
    },
    visible: {
        type: Boolean,
    },
    position: {
        type: String,
    },
    autoOpenAfterTime: {
        type: Boolean,
    },
    timeAutoOpen: {
        type: Number,
    },
    timeClosePopup: {
        type: Number,
    },
    onOpenLoadPage: {
        type: Boolean,
    },
    closeOverlay: {
        type: Boolean,
    },
    scrollYOpen: {
        type: Number,
    },
    scrollYClose: {
        type: Number,
    },
    overlay: {
        type: Boolean,
    },
    closeable: {
        type: Boolean,
    },
});
const TIME_DEFAULT = 5000;
const emit = defineEmits(["update:visible"]);
const closePopup = () => {
    emit("update:visible", false);
};
const openLoadPage = () => {
    emit("update:visible", true);
    localStorage.setItem(`popup-${props.keyPopup}`, true);
};
const timeClose = (time: any) =>
    props.timeClosePopup ? time + props.timeClosePopup : "";
const openAfterTime = () => {
    const timeOPen = () =>
        props.timeAutoOpen ? props.timeAutoOpen : TIME_DEFAULT;
    setTimeout(() => {
        emit("update:visible", true);
        localStorage.setItem(`popup-${props.keyPopup}`, true);
    }, timeOPen());

    setTimeout(() => {
        props.timeClosePopup ? emit("update:visible", false) : "";
    }, timeClose(timeOPen()));
};
const closeBeforeTime = () => {};
const { x, y } = useWindowScroll();

const scrollYOpen = () => {
    if (!localStorage.getItem(`popup-${props.keyPopup}`) && props.scrollYOpen) {
        if (y.value > props.scrollYOpen) {
            emit("update:visible", true);
            localStorage.setItem(`popup-${props.keyPopup}`, true);
        }
    }
};

const scrollYClose = () => {
    if (props.scrollYClose && y.value > props.scrollYClose) {
        emit("update:visible", false);
    }
};

const usePosition = (value: any) => {
    const positions: any = {
        center: "items-center justify-center inset-0 bounce-in pointer-events-none",
        top: "top-25 justify-center left-0 right-0 fade-in-down",
        left: "items-center justify-center inset-0 lg:left-4 lg:right-auto bounce-in-left pointer-events-none",
        right: "items-center justify-center inset-0 lg:left-auto lg:right-4 bounce-in-right pointer-events-none",
        bottom: "bottom-25 justify-center left-0 right-0 fade-in-up",
        "top-left":
            "top-25 justify-center left-0 right-0 lg:left-4 lg:right-auto bounce-in-left",
        "top-right":
            "top-25 justify-center left-0 right-0 lg:left-auto lg:right-4 bounce-in-right",
        "bottom-left":
            "bottom-25 justify-center left-0 right-0 lg:left-4 lg:right-auto bounce-in-left",
        "bottom-right":
            "bottom-25 justify-center left-0 right-0 lg:left-auto lg:right-4 bounce-in-right",
    };
    return !value ? positions.center : positions[value];
};
onMounted(() => {
    !localStorage.getItem(`popup-${props.keyPopup}`) && props.onOpenLoadPage
        ? openLoadPage()
        : false;
    !localStorage.getItem(`popup-${props.keyPopup}`) && props.autoOpenAfterTime
        ? openAfterTime()
        : false;
    !localStorage.getItem(`popup-${props.keyPopup}`) && props.scrollYOpen
        ? window.addEventListener("scroll", scrollYOpen)
        : false;
    window.addEventListener("scroll", scrollYClose);
});
</script>
<style lang="css" scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
.bounce-in-left {
    animation: bounce-in-left 1s ease;
}
@keyframes bounce-in-left {
    0% {
        opacity: 0;
        transform: translateX(-2000px);
    }
    60% {
        opacity: 1;
        transform: translateX(30px);
    }
    80% {
        transform: translateX(-10px);
    }
    100% {
        transform: translateX(0);
    }
}

.bounce-in-right {
    animation: bounce-in-right 1s ease;
}
@keyframes bounce-in-right {
    0% {
        opacity: 0;
        transform: translateX(2000px);
    }
    60% {
        opacity: 1;
        transform: translateX(-30px);
    }
    80% {
        transform: translateX(10px);
    }
    100% {
        transform: translateX(0);
    }
}

.bounce-in {
    animation: bounce-in 1s ease;
}
@keyframes bounce-in {
    0% {
        opacity: 0;
        transform: scale(0.4);
    }
    50% {
        opacity: 1;
        transform: scale(1.03);
    }
    70% {
        transform: scale(0.95);
    }
    100% {
        transform: scale(1);
    }
}

.fade-in-down {
    animation: fade-in-down 1s ease;
}
@keyframes fade-in-down {
    0% {
        opacity: 0;
        transform: translateY(-20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.fade-in-up {
    animation: fade-in-up 1s ease;
}
@keyframes fade-in-up {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
